import { getParamKeyFromTemplatePlaceholder, templatePlaceholderRegex } from './format-template';
export const hasAllTemplateParams = (format, params) => {
    const templatePlaceholders = format.match(templatePlaceholderRegex); // e.g. 'Hello ${a} ${b}' -> ['${a}', '${b}']
    if (!templatePlaceholders) {
        return true;
    }
    return templatePlaceholders.every(placeholder => {
        const paramKey = getParamKeyFromTemplatePlaceholder(placeholder); // e.g. ${a} -> a
        return params[paramKey] !== undefined;
    });
};
//# sourceMappingURL=has-all-template-params.js.map